import Token, { TIPOS_TOKEN } from './Token';

// El editor de fórmula simple con botonera gestiona la fórmula llevando
// el control de cada token. Cada token sería un +, un -, un 4,5,
// un competencia_123 etc
export default class TokenVariable extends Token {
  constructor(variable) {
    super(TIPOS_TOKEN.VARIABLE, variable.key, variable.label);
    this.variable = variable;
  }

  // eslint-disable-next-line class-methods-use-this
  siguienteValido(token) {
    if (token.valor === '(') {
      return false;
    }
    return token.tipo === TIPOS_TOKEN.OPERADOR;
  }
}
